var map = {
	"./01.png": 4637,
	"./02.png": 3958,
	"./03.png": 2047,
	"./04.png": 3392,
	"./05.png": 8217,
	"./06.png": 3074,
	"./07.png": 8427,
	"./08.png": 2188
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 3976;